export class Pharmacy {
    nabp: string;
    name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    distance: number;
    latitude: number;
    longitude: number;
    npi: string;
    directions: string;

    alwaysInclude: boolean;
    retail: boolean;
    mailOrder: boolean;
    speciality: boolean;
    preferred: boolean;
    preferredOrder: number;

    pharmacyIndicator: string;

    static getDirections(originLat, originLng, destLat, destLng) {
        return `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destLat},${destLng}`;
    };
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/pharmacy-locator/models/pharmacy.ts